import { render, staticRenderFns } from "./rubrics_table_filters.vue?vue&type=template&id=27458226&"
import script from "./rubrics_table_filters.vue?vue&type=script&lang=js&"
export * from "./rubrics_table_filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports